var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "payout-trans-details" },
    [
      _c(
        "div",
        { staticClass: "filter-section-container" },
        [
          _c("div", { staticClass: "filter-fixed" }, [
            _c("span", { staticClass: "filter-fixed-title" }, [
              _vm._v(_vm._s(_vm.$t("data.filter_section"))),
            ]),
            _c("i", {
              staticClass: "el-icon-arrow-down filter-fixed-arrow",
              class: { "fiter-icon-arrow-route": !_vm.showFilterContent },
              on: { click: _vm.onClickFixedArrow },
            }),
          ]),
          _c("el-collapse-transition", [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showFilterContent,
                    expression: "showFilterContent",
                  },
                ],
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "filter-content",
                    attrs: { id: "filter-content" },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "filter-item" },
                      [
                        _c("div", { staticClass: "filter-item-label" }, [
                          _vm._v(_vm._s(_vm.$t("merchantAccount.create_time"))),
                        ]),
                        _c("el-date-picker", {
                          staticClass: "filter-item-value",
                          attrs: {
                            size: "small",
                            format: "yyyy-MM-dd",
                            "value-format": "yyyy-MM-dd HH:mm:ss",
                            "default-time": ["00:00:00", "23:59:59"],
                            type: "daterange",
                            "range-separator": "~",
                            "start-placeholder": _vm.$t(
                              "components.start_date"
                            ),
                            "end-placeholder": _vm.$t("components.end_date"),
                          },
                          model: {
                            value: _vm.search.times,
                            callback: function ($$v) {
                              _vm.$set(_vm.search, "times", $$v)
                            },
                            expression: "search.times",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "filter-item" },
                      [
                        _c("div", { staticClass: "filter-item-label" }, [
                          _vm._v(
                            _vm._s(_vm.$t("merchantAccount.complete_time"))
                          ),
                        ]),
                        _c("el-date-picker", {
                          staticClass: "filter-item-value",
                          attrs: {
                            size: "small",
                            format: "yyyy-MM-dd",
                            "value-format": "yyyy-MM-dd HH:mm:ss",
                            "default-time": ["00:00:00", "23:59:59"],
                            type: "daterange",
                            "range-separator": "~",
                            "start-placeholder": _vm.$t(
                              "components.start_date"
                            ),
                            "end-placeholder": _vm.$t("components.end_date"),
                          },
                          model: {
                            value: _vm.search.complete_times,
                            callback: function ($$v) {
                              _vm.$set(_vm.search, "complete_times", $$v)
                            },
                            expression: "search.complete_times",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "filter-item" },
                      [
                        _c("div", { staticClass: "filter-item-label" }, [
                          _vm._v(
                            _vm._s(_vm.$t("merchantAccount.recipient_channel"))
                          ),
                        ]),
                        _c(
                          "el-select",
                          {
                            staticClass: "filter-item-value",
                            attrs: {
                              filterable: "",
                              size: "small",
                              clearable: "",
                            },
                            model: {
                              value: _vm.search.recipient_channel,
                              callback: function ($$v) {
                                _vm.$set(_vm.search, "recipient_channel", $$v)
                              },
                              expression: "search.recipient_channel",
                            },
                          },
                          _vm._l(_vm.bankList, function (item, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: {
                                label: item.bank_code,
                                value: item.bank_code,
                              },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "filter-item" },
                      [
                        _c("div", { staticClass: "filter-item-label" }, [
                          _vm._v(
                            _vm._s(_vm.$t("merchantAccount.transaction_status"))
                          ),
                        ]),
                        _c(
                          "el-select",
                          {
                            staticClass: "filter-item-value",
                            attrs: { size: "small", clearable: "" },
                            model: {
                              value: _vm.search.po_trans_status,
                              callback: function ($$v) {
                                _vm.$set(_vm.search, "po_trans_status", $$v)
                              },
                              expression: "search.po_trans_status",
                            },
                          },
                          _vm._l(
                            _vm.poTransactionStatusMap,
                            function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: { label: item.label, value: item.value },
                              })
                            }
                          ),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "filter-item" },
                      [
                        _c("div", { staticClass: "filter-item-label" }, [
                          _vm._v(
                            _vm._s(_vm.$t("customerService.merchant_order_id"))
                          ),
                        ]),
                        _c("el-input", {
                          staticClass: "filter-item-value",
                          attrs: { size: "small", type: "text", clearable: "" },
                          model: {
                            value: _vm.search.merchant_order_id,
                            callback: function ($$v) {
                              _vm.$set(_vm.search, "merchant_order_id", $$v)
                            },
                            expression: "search.merchant_order_id",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "filter-item" },
                      [
                        _c("div", { staticClass: "filter-item-label" }, [
                          _vm._v(
                            _vm._s(_vm.$t("customerService.transaction_id"))
                          ),
                        ]),
                        _c("el-input", {
                          staticClass: "filter-item-value",
                          attrs: { size: "small", type: "text", clearable: "" },
                          model: {
                            value: _vm.search.transaction_id,
                            callback: function ($$v) {
                              _vm.$set(_vm.search, "transaction_id", $$v)
                            },
                            expression: "search.transaction_id",
                          },
                        }),
                      ],
                      1
                    ),
                    _c("div", { staticClass: "filter-item" }),
                    _c("div", { staticClass: "filter-item" }),
                  ]
                ),
                _c("div", { staticClass: "filter-operate" }, [
                  _c(
                    "div",
                    { staticClass: "filter-operate-left" },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "mb-10 download-btn",
                          attrs: {
                            loading: _vm.downloading,
                            type: "info",
                            size: "small",
                            icon: "el-icon-download",
                          },
                          on: { click: _vm.onClickDowmloadBtn },
                        },
                        [_vm._v(_vm._s(_vm.$t("components.download")))]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "filter-operate-right" },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "search-btn mb-10",
                          attrs: { size: "small" },
                          on: { click: _vm.onClickReset },
                        },
                        [_vm._v(_vm._s(_vm.$t("components.clear")))]
                      ),
                      _c(
                        "el-button",
                        {
                          staticClass: "search-btn mb-10",
                          attrs: {
                            type: "primary",
                            size: "small",
                            icon: "el-icon-search",
                          },
                          on: { click: _vm.handleFilter },
                        },
                        [_vm._v(_vm._s(_vm.$t("components.search")))]
                      ),
                    ],
                    1
                  ),
                ]),
              ]
            ),
          ]),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "tableContainer" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData,
                stripe: "",
                fit: "",
                "highlight-current-row": "",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("customerService.transaction_id"),
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [_vm._v(_vm._s(scope.row.transaction_id))]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("merchantAccount.merchant_order_id"),
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(_vm._s(scope.row.merchant_order_id)),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("merchantAccount.recipient_channel"),
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(_vm._s(scope.row.recipient_channel || "/")),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm.isShowFXRow
                ? _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("data.source_amount"),
                      align: "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm._f("toDivideWithDot")(
                                        scope.row.source_amount
                                      )
                                    ) +
                                    " " +
                                    _vm._s(scope.row.source_currency)
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1881406567
                    ),
                  })
                : _vm._e(),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("data.destination_amount"),
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.transaction_type === _vm.TRANSACTION_TYPE_FX
                          ? _c("div", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm._f("toDivideWithDot")(
                                      scope.row.destination_amount
                                    )
                                  ) +
                                  " " +
                                  _vm._s(scope.row.destination_currency) +
                                  " "
                              ),
                            ])
                          : _c("div", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm._f("toDivideWithDot")(
                                      scope.row.po_trans_amount
                                    )
                                  ) +
                                  " "
                              ),
                              _vm.isShowFXRow
                                ? _c("span", [
                                    _vm._v(_vm._s(_vm.$store.getters.currency)),
                                  ])
                                : _vm._e(),
                            ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("merchant.service_fee"),
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.transaction_type === _vm.TRANSACTION_TYPE_FX
                          ? _c("div", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("toDivideWithDot")(
                                    scope.row.mch_foreign_exchange_fee_resp
                                      .fee_split
                                  )
                                ) +
                                  " " +
                                  _vm._s(
                                    scope.row.mch_foreign_exchange_fee_resp
                                      .fee_split_currency
                                  )
                              ),
                            ])
                          : _c("div", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("toDivideWithDot")(scope.row.fee_split)
                                ) + " "
                              ),
                              _vm.isShowFXRow
                                ? _c("span", [
                                    _vm._v(_vm._s(_vm.$store.getters.currency)),
                                  ])
                                : _vm._e(),
                            ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("merchantAccount.po_trans_status"),
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            staticClass: "tag-custom",
                            attrs: {
                              type: _vm.getPoTransactionStatusStyle(
                                scope.row.po_trans_status
                              ),
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.getPoTransactionStatusMap(
                                  scope.row.po_trans_status,
                                  scope.row.refund_type
                                )
                              )
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("merchantAccount.create_time"),
                  align: "center",
                  width: "105",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(_vm._s(scope.row.transaction_create_time)),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("merchantAccount.complete_time"),
                  align: "center",
                  width: "105",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(_vm._s(scope.row.transaction_return_time)),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  "min-width": "110",
                  label: _vm.$t("data.remark"),
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        !scope.row.remark || scope.row.remark.length <= 10
                          ? _c("span", [_vm._v(_vm._s(scope.row.remark))])
                          : _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  effect: "light",
                                  content: scope.row.remark,
                                  placement: "top",
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "show-ellipsis",
                                    staticStyle: {
                                      cursor: "pointer",
                                      display: "inline-block",
                                      "max-width": "100px",
                                    },
                                  },
                                  [_vm._v(_vm._s(scope.row.remark))]
                                ),
                              ]
                            ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("components.operation"),
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tooltip",
                          { attrs: { placement: "top" } },
                          [
                            _c(
                              "div",
                              { attrs: { slot: "content" }, slot: "content" },
                              [
                                _c("span", [
                                  _vm._v(
                                    " " + _vm._s(_vm.$t("components.detail"))
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("br"),
                              ]
                            ),
                            _c("svg-icon", {
                              attrs: {
                                "class-name": "icon-function",
                                "icon-class": "operation-detail",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.onClickDetailTxt(scope.row)
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination-container" },
            [
              !_vm.listLoading
                ? _c("paginator", {
                    attrs: { "list-query": _vm.listQuery },
                    on: { "paginator-change": _vm.onClickPaginator },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c("po-details-modal", {
        ref: "poMentDetailsModal",
        attrs: { "detail-id": _vm.detailId },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }